export default "__VITE_ASSET__DTfy42oQ__"